(() => {
  'use strict';
  const KEY = 'BosscoAccessoryLanding';
  if (window[KEY]) { window[KEY].scan(); return; }
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false, frame = 0, reveals, parallax = [], active = false;
  let purchase, purchaseObserver, purchaseContainer, purchaseForm, syncing = false, cartErrorsBound = false;
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const html = document.documentElement;
  const motionRoots = '[data-bc-accessory-landing], [data-bc-accessory-story]';
  const previewView = new URL(location.href).searchParams.get('view');
  function scan() {
    const hero = document.querySelector('[data-bc-accessory-landing]');
    const motion = !!hero && !reduce.matches && !paused && hero.dataset.bcMotion !== 'false';
    active = !!hero;
    html.classList.toggle('bc-accessory-page', !!hero);
    html.classList.toggle('bc-accessory-motion-on', active && motion);
    reveals?.disconnect();
    if (active && motion && 'IntersectionObserver' in window) {
      reveals = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('bc-accessory-in-view'); reveals.unobserve(entry.target); }
      }), { threshold: .08, rootMargin: '0px 0px -20px 0px' });
      document.querySelectorAll('.bc-accessory-landing-section [data-bc-reveal]').forEach(node => reveals.observe(node));
    } else document.querySelectorAll('.bc-accessory-landing-section [data-bc-reveal]').forEach(node => node.classList.add('bc-accessory-in-view'));
    parallax = Array.from(document.querySelectorAll('[data-bc-accessory-landing] [data-bc-parallax], [data-bc-accessory-story] [data-bc-parallax]'));
    document.querySelectorAll('[data-bc-accessory-landing] [data-bc-motion-toggle], [data-bc-accessory-story] [data-bc-motion-toggle]').forEach(button => {
      button.hidden = reduce.matches || hero?.dataset.bcMotion === 'false';
      button.setAttribute('aria-pressed', String(paused));
      button.innerHTML = paused ? 'Play motion <span aria-hidden="true"><svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" aria-hidden="true" focusable="false" style="vertical-align:middle"><path d="m8 5 11 7-11 7Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' : 'Pause motion <span aria-hidden="true"><svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" aria-hidden="true" focusable="false" style="vertical-align:middle"><path d="M9 5v14M15 5v14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    });
    connectPurchase();
    tick();
  }
  function tick() {
    frame = 0;
    const motion = html.classList.contains('bc-accessory-motion-on');
    const hero = document.querySelector('[data-bc-accessory-landing]');
    if (hero) {
      const box = hero.getBoundingClientRect();
      hero.style.setProperty('--bc-accessory-hero-scale', motion ? (1.025 + clamp(-box.top / box.height, 0, 1) * .11).toFixed(3) : '1');
      const progress = document.querySelector('[data-bc-page-progress]');
      progress?.style.setProperty('--bc-page-progress', String(clamp(scrollY / Math.max(1, document.documentElement.scrollHeight - innerHeight), 0, 1)));
    }
    for (const el of parallax) {
      if (!motion || innerWidth < 900) { el.style.removeProperty('--bc-parallax-y'); continue; }
      const box = el.parentElement.getBoundingClientRect();
      if (box.top > innerHeight || box.bottom < 0) continue;
      const amount = Math.max(-65, Math.min(65, (innerHeight / 2 - box.top - box.height / 2) * (Number(el.dataset.bcParallax) || .08)));
      el.style.setProperty('--bc-parallax-y', `${amount.toFixed(2)}px`);
    }
  }
  function revealPurchase() {
    const target = document.querySelector('#bc-accessory-hero');
    target?.scrollIntoView({behavior:html.classList.contains('bc-accessory-motion-on')?'smooth':'auto',block:'start'});
  }
  function syncPurchase() {
    if (!purchase?.isConnected || !purchaseForm?.isConnected || syncing || purchase.dataset.bcInvalid === 'true') return;
    const id = purchaseForm.querySelector('[name="id"]')?.value;
    const variant = purchase.variants.find(item => String(item.id) === String(id));
    const nativeButton = purchaseForm.querySelector('button[type="submit"]');
    const price = purchase.querySelector('[data-bc-price]');
    const compare = purchase.querySelector('[data-bc-compare]');
    const select = purchase.querySelector('[data-bc-variant]');
    const button = purchase.querySelector('[data-bc-add]');
    const status = purchase.querySelector('[data-bc-purchase-status]');
    if (variant) {
      price.innerHTML = variant.price;
      compare.innerHTML = variant.compare || '';
      compare.hidden = !variant.compare;
      if (select) select.value = String(variant.id);
      purchase.querySelectorAll('[data-bc-option-index]').forEach(option => { option.value = variant.options[Number(option.dataset.bcOptionIndex)]; });
      // Persist selection for galleries initialized after the native purchase bridge.
      // Only a variant change selects a photo; price/cart updates must not reset browsing.
      if (purchase.dataset.bcGalleryVariant !== String(variant.id)) {
        purchase.dataset.bcGalleryVariant = String(variant.id);
        purchase.dataset.bcGalleryImage = variant.imageId ? String(variant.imageId) : '';
        purchase.dispatchEvent(new CustomEvent('bc:accessory:variant-change', {
          bubbles: true,
          detail: { variantId: variant.id, imageId: variant.imageId || null }
        }));
      }
    }
    const busy = nativeButton?.classList.contains('btn--in-progress');
    button.disabled = !variant?.available || !nativeButton || nativeButton.disabled || busy;
    button.setAttribute('aria-busy',String(!!busy));
    const text = busy ? 'Adding…' : !variant ? 'Choose your options' : !variant.available ? 'Sold out' : nativeButton?.textContent.trim() || 'Add to cart';
    purchase.querySelector('[data-bc-add-label]').textContent = text;
    if (!purchase.dataset.bcError) status.textContent = !variant ? 'Choose your accessory options.' : !variant.available ? 'This option is currently sold out.' : variant.backorder ? 'Available on backorder. Check the restock details.' : 'Available to order';
  }
  function connectPurchase() {
    const panel = document.querySelector('[data-bc-accessory-landing] [data-bc-purchase]');
    const container = Array.from(document.querySelectorAll('[data-section-type="main-product"] .product-form')).find(node => node.dataset.productId === panel?.dataset.productId);
    const form = container?.querySelector('form.product-purchase-form');
    if (!panel || !container || !form) {
      purchaseObserver?.disconnect();
      panel?.querySelectorAll('[data-bc-purchase-controls]').forEach(node => node.hidden = true);
      const fallback = panel?.querySelector('[data-bc-purchase-fallback]');
      if (fallback) fallback.hidden = false;
      purchase = purchaseContainer = purchaseForm = null; return;
    }
    if (panel === purchase && container === purchaseContainer && form === purchaseForm) { syncPurchase(); return; }
    purchaseObserver?.disconnect();
    purchase = panel; purchaseContainer = container; purchaseForm = form;
    try { panel.variants = JSON.parse(panel.querySelector('[data-bc-variants]').textContent); } catch { return; }
    const ready = () => {
      if (!container.classList.contains('theme-init')) return;
      bindCartErrors();
      panel.querySelectorAll('[data-bc-purchase-controls]').forEach(node => node.hidden = false);
      panel.querySelector('[data-bc-purchase-fallback]').hidden = true;
      syncPurchase();
    };
    purchaseObserver = new MutationObserver(ready);
    purchaseObserver.observe(container,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','class','value']});
    ready();
  }
  function bindCartErrors() {
    if (cartErrorsBound || !window.jQuery) return;
    cartErrorsBound = true;
    window.jQuery(document).on('ajaxError.bcAccessory', (_event, xhr, settings) => {
      if (!purchase?.isConnected || !/\/cart\/add/.test(settings.url || '')) return;
      let message = 'Unable to add this item. Check your selection and try again.';
      try { const response = JSON.parse(xhr.responseText); if (typeof response.description === 'string') message = response.description; } catch { /* Keep the useful fallback. */ }
      purchase.dataset.bcError = 'true';
      const errorStatus = purchase.querySelector('[data-bc-purchase-status]');
      errorStatus.textContent = message;
      errorStatus.hidden = false;
      syncPurchase();
    });
  }
  document.addEventListener('change', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.matches('[data-bc-option-index]') && purchase?.contains(event.target)) {
      const options = Array.from(purchase.querySelectorAll('[data-bc-option-index]')).map(select => select.value);
      const match = purchase.variants.find(variant => variant.options.every((value,index) => value === options[index]));
      if (!match) {
        purchase.dataset.bcInvalid = 'true';
        purchase.querySelector('[data-bc-price]').textContent = '—';
        purchase.querySelector('[data-bc-compare]').hidden = true;
        purchase.querySelector('[data-bc-add]').disabled = true;
        purchase.querySelector('[data-bc-add-label]').textContent = 'Unavailable combination';
        purchase.querySelector('[data-bc-purchase-status]').textContent = 'This combination is unavailable. Choose another option.';
        return;
      }
      delete purchase.dataset.bcInvalid;
      const combined = purchase.querySelector('[data-bc-variant]');
      combined.value = String(match.id);
      combined.dispatchEvent(new Event('change', {bubbles:true}));
      return;
    }
    if (event.target.matches('[data-bc-variant]') && purchase?.contains(event.target)) {
      const variant = purchase?.variants.find(item => String(item.id) === event.target.value);
      if (!variant || !purchaseForm) return;
      delete purchase.dataset.bcError;
      const currentView = new URL(location.href).searchParams.get('view');
      syncing = true;
      // Use Mode's own selector API so visible options, app listeners and variant state agree.
      purchaseContainer.querySelectorAll('.option-selector').forEach((selector,index) => {
        const value = variant.options[index];
        const custom = selector.querySelector('.cc-select');
        if (custom) custom.dispatchEvent(new CustomEvent('selectOption',{detail:{value}}));
        else {
          const radio = Array.from(selector.querySelectorAll('input.js-option')).find(input => input.value === value);
          if (radio && !radio.checked) radio.click();
        }
      });
      purchaseContainer.querySelectorAll('[name="id"]').forEach(input => {
        input.value = String(variant.id);
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
      // Mode updates the variant URL; keep this alternate-template preview selected.
      if (currentView) { const url = new URL(location.href); url.searchParams.set('view',currentView); history.replaceState(history.state,'',url); }
      syncing = false;
      syncPurchase();
    } else if (purchaseContainer?.contains(event.target)) {
      delete purchase.dataset.bcError;
      queueMicrotask(() => {
        if (previewView) { const url = new URL(location.href); url.searchParams.set('view',previewView); history.replaceState(history.state,'',url); }
        syncPurchase();
      });
    }
  });
  function schedule() { if (active && !frame) frame = requestAnimationFrame(tick); }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const add = event.target.closest('[data-bc-add]');
    if (add && purchase?.contains(add)) {
      const nativeButton = purchaseForm?.querySelector('button[type="submit"]');
      if (!nativeButton || nativeButton.disabled) { syncPurchase(); return; }
      if (!purchaseForm.checkValidity()) { revealPurchase(); purchaseForm.reportValidity(); return; }
      delete purchase.dataset.bcError;
      nativeButton.click();
      syncPurchase();
      return;
    }
    const toggle = event.target.closest('[data-bc-motion-toggle]');
    if (toggle?.closest(motionRoots)) { paused = !paused; scan(); return; }
    if (event.defaultPrevented) return;
    const link = event.target.closest('[data-bc-accessory-landing] a[href^="#bc-accessory-"], [data-bc-accessory-story] a[href^="#bc-accessory-"]');
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: html.classList.contains('bc-accessory-motion-on') ? 'smooth' : 'auto', block: 'start' });
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
    target.focus({ preventScroll: true });
  });
  addEventListener('scroll', schedule, { passive:true });
  addEventListener('resize', scan, { passive:true });
  reduce.addEventListener('change', scan);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', () => setTimeout(scan,0));
  document.addEventListener('shopify:section:reorder', scan);
  document.addEventListener('bc:recommendations:loaded',scan);
  window[KEY] = {scan};
  addEventListener('load',connectPurchase,{once:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan,{once:true}); else scan();
})();
